var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    fill: "white",
    stroke: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 20.5366V26.5111C13.125 27.8163 14.1683 28.8749 15.4546 28.8749H26.5454C27.8317 28.8749 28.875 27.8163 28.875 26.5111V25.2495",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4786 20.1831C13.2833 19.9878 12.9667 19.9878 12.7714 20.1831L9.58947 23.365C9.3942 23.5603 9.3942 23.8769 9.58947 24.0722C9.78473 24.2674 10.1013 24.2674 10.2966 24.0722L13.125 21.2437L15.9534 24.0722C16.1487 24.2674 16.4653 24.2674 16.6605 24.0722C16.8558 23.8769 16.8558 23.5603 16.6605 23.365L13.4786 20.1831ZM12.625 20.5366V26.5111H13.625V20.5366H12.625ZM12.625 26.5111C12.625 28.0855 13.8854 29.3749 15.4546 29.3749V28.3749C14.4513 28.3749 13.625 27.547 13.625 26.5111H12.625ZM15.4546 29.3749H26.5454V28.3749H15.4546V29.3749ZM26.5454 29.3749C28.1146 29.3749 29.375 28.0855 29.375 26.5111H28.375C28.375 27.547 27.5487 28.3749 26.5454 28.3749V29.3749ZM29.375 26.5111V25.2495H28.375V26.5111H29.375Z",
    fill: "#3A77BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 21.4632V15.4877C28.875 14.1831 27.8319 13.125 26.5459 13.125H15.4541C14.1681 13.125 13.125 14.1831 13.125 15.4877V16.7487",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5214 21.8168C28.7167 22.0121 29.0333 22.0121 29.2286 21.8168L32.4105 18.6348C32.6058 18.4395 32.6058 18.123 32.4105 17.9277C32.2153 17.7324 31.8987 17.7324 31.7034 17.9277L28.875 20.7561L26.0466 17.9277C25.8513 17.7324 25.5347 17.7324 25.3395 17.9277C25.1442 18.123 25.1442 18.4395 25.3395 18.6348L28.5214 21.8168ZM29.375 21.4632V15.4877H28.375V21.4632H29.375ZM29.375 15.4877C29.375 13.9138 28.1148 12.625 26.5459 12.625V13.625C27.549 13.625 28.375 14.4525 28.375 15.4877H29.375ZM26.5459 12.625H15.4541V13.625H26.5459V12.625ZM15.4541 12.625C13.8852 12.625 12.625 13.9138 12.625 15.4877H13.625C13.625 14.4525 14.451 13.625 15.4541 13.625V12.625ZM12.625 15.4877V16.7487H13.625V15.4877H12.625Z",
    fill: "#3A77BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButton);
export default __webpack_public_path__ + "static/media/RefreshButton.c65e0351f37dcb9f54fabbcdad6dccbe.svg";
export { ForwardRef as ReactComponent };